import { filter, mergeMap } from 'rxjs/operators';

import { COAST_SUPPORT_EMAIL, COAST_VOICE_PHONE } from '../../../env';
import { RootEpic } from '../../../store/epics';
import { lookupAddress, lookupAddressFail, lookupAddressSuccess } from '../reducers/addressLookup';

const lookupAddressEpic: RootEpic = (action$, _state$, { api }) => {
  return action$.pipe(
    filter(lookupAddress.match),
    mergeMap(({ payload: { address } }) => {
      return api.addressLookup
        .lookupAddress(address)
        .then(lookupAddressSuccess)
        .catch((error) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          return lookupAddressFail({
            ...error,
            message:
              'Our server is having trouble verifying your address, ' +
              'please try again. If you continue to see this error, ' +
              `email us at ${COAST_SUPPORT_EMAIL}, or call us at ${COAST_VOICE_PHONE}`,
          });
        });
    }),
  );
};

export { lookupAddressEpic };
